export default class Menu {
  "use strict"

  //limiteMenuFixo = 200;  //Define o ponto scrollY em que o menu fixo será ativado

  constructor() {
    return this;
  }

  /* iniciar = function () {
    this.iniciarEventos();
    this.iniciarMenuFixo();
  } */

  /* Inicia os eventos que controlam o menu fixo */
  definirMenuFixo = function (menuFixo, limite) {

    this.menuFixo = menuFixo;
    this.limite = limite;

    if (this.menuFixo) {
      document.addEventListener('scroll', () => { this.alternarMenuFixo() })
      window.addEventListener('load', () => { this.alternarMenuFixo() })
    }
  }

  /* Fixa e desafixa o menu fixo de acordo com a posição do scroll na tela */
  alternarMenuFixo = function () {
        if (scrollY > this.limite) {
      this.menuFixo.classList.add('visivel')
    } else {
      this.menuFixo.classList.remove('visivel')
    }
  }


}
